<template>
  <div class="ActivityLogs">
    <h1 class="text-center">Activity logs</h1>
    <div class="row">
      <div class="col">
        <label for="actionSelected">Actions</label>
        <multiselect
          id="actionSelected"
          v-model="actionSelected"
          :options="actionOptions"
          label="text"
          track-by="id"
          placeholder="เลือก Actions"
        >
        </multiselect>
      </div>
      <div class="col">
        <label for="actionBy">Action by</label>
        <input
          id="actionBy"
          class="form-control"
          type="text"
          v-model="actionBy"
        />
      </div>
      <div class="col">
        <label for="referenceData">Reference data</label>
        <input
          id="referenceData"
          class="form-control"
          type="text"
          v-model="ReferenceData"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="startDate">Start date</label>
        <date-picker
          id="startDate"
          v-bind="$attrs"
          v-model="startDate"
          format="D MMMM yyyy"
          :value="startDate"
          :lang="'en'"
          @change="startDate = $event"
        />
        <div class="row">
          <div class="col-3">
            <label for="hourStartSelected">Hour</label>
            <multiselect
              id="hourStartSelected"
              v-model="hourStartSelected"
              :options="hours"
              :allow-empty="false"
              :show-labels="false"
              placeholder=""
            >
            </multiselect>
          </div>
          <div class="col-3">
            <label for="minuteStartSelected">Minute</label>
            <multiselect
              id="minuteStartSelected"
              v-model="minuteStartSelected"
              :options="minutes"
              :allow-empty="false"
              :show-labels="false"
              placeholder=""
            >
            </multiselect>
          </div>
        </div>
      </div>
      <div class="col">
        <label for="endDate">End date</label>
        <date-picker
          id="endDate"
          v-bind="$attrs"
          v-model="endDate"
          format="D MMMM yyyy"
          :value="endDate"
          :lang="'en'"
          @change="endDate = $event"
        />
        <div v-if="endDate" class="row">
          <div class="col-3">
            <label for="hourEndSelected">Hour</label>
            <multiselect
              id="hourEndSelected"
              v-model="hourEndSelected"
              :options="hours"
              :allow-empty="false"
              :show-labels="false"
              placeholder=""
            >
            </multiselect>
          </div>
          <div class="col-3">
            <label for="minuteEndSelected">Minute</label>
            <multiselect
              id="minuteEndSelected"
              v-model="minuteEndSelected"
              :options="minutes"
              :allow-empty="false"
              :show-labels="false"
              placeholder=""
            >
            </multiselect>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex group-button">
      <button class="btn btn-outline-dark mr-5" @click="resetSearch">Reset</button>
      <button class="btn btn-outline-primary" @click="submitSearch">
        Submit
      </button>
    </div>
    <div class="mt-5 row">
      <b-table
        class="table table-bordered mt-5"
        hover
        :fields="fields"
        :items="listLogs"
        :per-page="perPage"
        :busy="isLoading"
        @sort-changed="sortCompare"
        show-empty
      >
        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template #cell(jsonText)="data">
          <pre>{{ data.item.jsonText }}</pre>
        </template>
        <template #empty>
          <h4 class="text-center p-5">ไม่มีข้อมูลที่แสดง</h4>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import auditLogs from "@/services/api/auditlogs.service.js";
export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalItems: null,
      actionBy: "",
      ReferenceData: "",
      actionSelected: null,
      actionOptions: [],
      hours: [],
      hourStartSelected: "00",
      hourEndSelected: "23",
      minutes: [],
      minuteStartSelected: "00",
      minuteEndSelected: "59",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: null,
      listLogs: [],

      sort: {
        key: null,
        type: false,
      },
      fields: [
        {
          key: "dateShow",
          label: "Date",
          tdClass: ["align-middle", "right-border", "date-text"],
          thStyle: { "border-right": "1px solid #DEE2E6" },
          sortable: true,
        },
        {
          key: "userFullName",
          label: "Action by",
          tdClass: ["align-middle", "right-border", "user-text"],
          thStyle: { "border-right": "1px solid #DEE2E6" },
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          tdClass: ["align-middle", "right-border", "action-text"],
          thStyle: { "border-right": "1px solid #DEE2E6" },
          sortable: true,
        },
        {
          key: "referenceData",
          label: "Reference data",
          tdClass: ["align-middle", "right-border", "reference-text"],
          thStyle: { "border-right": "1px solid #DEE2E6" },
          sortable: true,
        },
        {
          key: "ipAddress",
          label: "IP Address",
          tdClass: ["align-middle", "right-border", "ip-text"],
          thStyle: { "border-right": "1px solid #DEE2E6" },
          sortable: true,
        },
        {
          key: "jsonText",
          label: "Data",
          tdClass: ["align-middle", "data-text"],
          sortable: false,
        },
      ],
      isLoading: false,
    };
  },
  mounted() {
    this.setDropdownAction();
    this.getList(this.sort);
    this.genHourList();
    this.genMinuteList();
  },
  methods: {
    async setDropdownAction() {
      try {
        await auditLogs
          .getListActionsAudit()
          .then(
            (res) => {
              const data = res.data;
              this.actionOptions = data.actions.map((a) => {
                return {
                  id: a,
                  text: a,
                };
              });
            },
            (error) => {
              alert("Can't get data: ", error);
            }
          )
          .catch((err) => {
            console.log("Error: ", err);
          });
      } catch (ex) {
        console.log("Exception: ", ex);
      }
    },
    async getList(sort) {
      this.isLoading = true;

      try {
        const params = {
          actionId: this.actionSelected ? this.actionSelected.id : null,
          user: this.actionBy,
          referenceData: this.ReferenceData,
          fromDate: moment(this.startDate, "YYYY-MM-DD").format(
            `YYYY-MM-DD ${this.hourStartSelected}:${this.minuteStartSelected}:00`
          ),
          toDate: this.endDate
            ? moment(this.endDate, "YYYY-MM-DD").format(
                `YYYY-MM-DD ${this.hourEndSelected}:${this.minuteEndSelected}:59`
              )
            : "",
          currentPage: this.currentPage,
          limit: this.perPage,
          sortColumn: sort.key || "",
          sortType: sort.type || "",
        };
        await auditLogs
          .getListAuditLogs(params)
          .then(
            (res) => {
              const data = res.data;
              this.isLoading = false;
              this.totalItems = data.totalItems;
              this.listLogs = data.logs.map((c) => {
                return {
                  dateShow: moment(c.date).format("YYYY-MM-DD HH:mm:ss"),
                  jsonText: c.data, //JSON.parse(c.data),
                  ...c,
                };
              });
            },
            (error) => {
              this.isLoading = false;
              console.log("Error: ", error);
            }
          )
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (ex) {
        this.isLoading = false;
        console.log("Exception: ", ex);
      }
    },

    genHourList() {
      for (let i = 0; i <= 23; i++) {
        let setFormat = i.toString().length === 1 ? `0${i}` : i.toString();
        this.hours.push(setFormat);
      }
    },
    genMinuteList() {
      for (let i = 0; i < 60; i++) {
        let setFormat = i.toString().length === 1 ? `0${i}` : i.toString();
        this.minutes.push(setFormat);
      }
    },
    submitSearch() {
      this.getList(this.sort);
    },
    resetSearch() {
      this.actionSelected = null
      this.actionBy = ""
      this.ReferenceData = ""
      this.startDate = moment().format("YYYY-MM-DD")
      this.hourStartSelected = "00"
      this.minuteStartSelected = "00"
      this.endDate = null
      this.hourEndSelected = "23"
      this.minuteEndSelected = "59"
      this.getList(this.sort);
    },
    changePage() {
      this.getList(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      if (sortBy === "dateShow") {
        sortBy = "dateCreated";
      } else if (sortBy === "action") {
        sortBy = "actionType";
      } else if (sortBy === "userFullName") {
        sortBy = "userId";
      }
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-button {
  justify-content: flex-end;
}

::v-deep .first-options {
  color: red;
}

::v-deep .right-border {
  border-right: 1px solid #dee2e6;
}

::v-deep .table td {
  white-space: normal;
  word-break: break-word;
}

::v-deep .date-text {
  min-width: 120px;
}

::v-deep .reference-text {
  min-width: 200px;
}

::v-deep .user-text {
  min-width: 130px;
}

::v-deep .action-text {
  min-width: 16vw;
}

::v-deep .ip-text {
  min-width: 150px;
}

::v-deep .data-text {
  min-width: 16vw;
  max-width: 50vw;
}

::v-deep .data-text pre {
  white-space: normal;
  word-break: break-word;
  overflow-y: auto;
  max-height: 100px;
}

.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
